import { IMeshOptions } from '@/types';

import { AnnoFactory } from './AnnoFactory';
import { Circle3d } from './Circle3d';

export class Circle2d {
  /**
   * 创建 2D 圆形
   * @param data [x, y, r] three.js 坐标系
   * @param options 配置项
   * @returns
   */
  static create(data: number[], options: IMeshOptions) {
    const circle = Circle3d.create([data[0], data[1], 0, data[2]], options);
    circle.position.setZ(AnnoFactory.generateObjectZ(circle));
    return circle;
  }
}
